import { css } from "@emotion/react";
import Grid from "@mui/material/Grid";

import { colors } from "@dotnet/telematics-design-system";

import { SingleCompatibilityCardProps } from "./types";

const SingleCompatibilityCard = ({
    title,
    value
}: SingleCompatibilityCardProps) => {
    const { gray200, gray700, gray900 } = colors;

    return (
        <Grid
            container
            css={css({
                padding: "10px 0",
                borderBottom: `1px solid ${gray200}`,
                fontSize: "14px",
                lineHeight: "20px",
                letterSpacing: "0.1px",
                wordBreak: "break-word",

                "& > div:first-of-type": {
                    color: gray700,
                    paddingRight: "8px"
                },

                "& > div:last-of-type": {
                    color: gray900,
                    padding: "0 8px",
                    fontWeight: "500"
                }
            })}
        >
            <Grid size={{ xs0: 6 }}>{title}:</Grid>
            <Grid size={{ xs0: 6 }}>{value}</Grid>
        </Grid>
    );
};

export default SingleCompatibilityCard;
